import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHANGE_ROLE_MODAL';
export const {
    action: removeLogin,
    success: removeLoginSuccess,
    failed: removeLoginFailed,
    aborted: removeLoginAborted,
} = createAction(
    `${domain}/REMOVE_LOGIN`,
    (assignee, overrideTargetType) => ({assignee, overrideTargetType}),
    assignee => ({assignee}),
    (assignee, message) => ({assignee, message}),
);

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (assignee, overrideTargetType, usePincodeCheckin, overrideSubmit, hideRemoveLogin) => ({
        assignee,
        overrideTargetType,
        usePincodeCheckin,
        overrideSubmit,
        hideRemoveLogin,
    }),
);

export const {action: close} = createAction(`${domain}/CLOSE`, () => ({}));

export const {
    action: changeRole,
    success: changeRoleSuccess,
    failed: changeRoleFailed,
} = createAction(`${domain}/CHANGE_ROLE`, (assignee, newRoleId, overrideTargetType) => ({
    assignee,
    newRoleId,
    overrideTargetType,
}));

export const {
    action: assignRole,
    success: assignRoleSuccess,
    failed: assignRoleFailed,
} = createAction(`${domain}/ASSIGN_LOGIN`, (assignee, newEmail, newRoleId, overrideTargetType) => ({
    assignee,
    newEmail,
    newRoleId,
    overrideTargetType,
}));
